import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import Insumo from './components/Insumo';

export default function indexInsumo() {
  return (
    <>
      <MainContent
        titulo='Insumo'
        component={<Insumo />}
        noBackground
        roundedBottomOnly
      />
      
      <Outlet />
    </>
  );
}